import React, { useMemo, useState } from 'react'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { IconList } from '../../../../../shared/icon/icon'
import { useParamsInt } from '../../../../../shared/hooks/location'
import { LoginDetails } from './login-edit/login-details'
import { LoginPassword } from './login-edit/login-password'
import { LoginAIToolsSharing } from './login-edit/login-ai-tools-sharing'
import { TileBody, TileColumn11112 } from '../../../../../shared/tile/tile-column-21111'
import { useApiFormLogin, useApiListLogin } from '../../../../../api-new/state/content'
import { ScrollY } from '../../../../../shared/component/scroll'
import { Menu } from '../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { Card } from '../../../../../shared/card/card'
import { useLoad } from '../../../../../shared/hooks/load'
import { useLoginMenuItems } from './common/login-menu-items'
import { errorMessageOf } from '../../../../../shared/error/error-notice'
import { ErrorReference } from '../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../shared/error/use-error-line'

export const LoginEdit = () => {
  const { loginID } = useParamsInt()

  const apiFormLogin = useApiFormLogin()

  const handlePath = () => apiFormLogin.get(loginID)

  // the Logins row menu's items, less Edit (this page)
  const loginMenuItems = useLoginMenuItems()
  const HeaderMenu = () => <Menu>{loginMenuItems(loginID)}</Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text={apiFormLogin.form.email} onPath={handlePath}>
        <CardFullHeightScrollY title={apiFormLogin.form.email} HeaderMenu={HeaderMenu}>
          <ScrollY>
            <TileBody>
              <TileColumn11112>
                <LoginDetails form={apiFormLogin} />
              </TileColumn11112>
              <TileColumn11112>
                <LoginPassword loginID={loginID} />
                <CurrentOrganization loginID={loginID} />
                <LoginAIToolsSharing loginID={loginID} />
              </TileColumn11112>
            </TileBody>
          </ScrollY>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}

const CurrentOrganization = ({ loginID }) => {
  const apiListLogin = useApiListLogin()

  const [error, failure, updateError] = useErrorLine()
  const [submitting, updateSubmitting] = useState(false)

  useLoad(() => loginID && apiListLogin.get(`${loginID}/user-organization`), [loginID])

  const selectedIndex = useMemo(() => apiListLogin.items.findIndex(item => item.isActive), [apiListLogin.items])

  const handleChange = async index => {
    try {
      updateError(null)
      updateSubmitting(true)
      let item = apiListLogin.items[index]
      await apiListLogin.put(`${loginID}/user-organization`, item)
    } catch (exception) {
      // A network failure has no body (api-new throws undefined).
      updateError(errorMessageOf(exception, "The current organization couldn't be changed."), exception)
    } finally {
      updateSubmitting(false)
    }
  }

  return (
    <Card title="Current Organization">
      <div className="m-2">
        <Select items={apiListLogin.items} display="organizationName" selectedIndex={selectedIndex} disabled={submitting} onChange={handleChange} />
      </div>
      {error &&
        <div className="m-2 text-danger" role="alert">
          {error}
          <ErrorReference error={failure} />
        </div>}
    </Card>
  )
}

const Select = ({ items, display, selectedIndex, disabled, onChange }) => {
  const handleChange = e => {
    let index = parseInt(e.target.value)
    onChange && onChange(index)
  }

  return (
    <select className="form-control" value={selectedIndex} disabled={disabled} onChange={handleChange}>
      <option value={NaN}>None</option>
      {items.map((item, i) =>
        <option key={i} value={i}>
          {item[display]}
        </option>
      )}
    </select>
  )
}
